export function country_areas(state){
    return state.country_areas
}

export function faq_categories(state){
    return state.faq_categories
}

export function genders(state){
    return state.genders
}

export function group_users_labels(state){
    return state.group_users_labels
}

export function groups_user(state){
    return state.groups_user
}

export function library_file_categories(state){
    return state.library_file_categories
}

export function library_file_extensions(state){
    return state.library_file_extensions
}

export function marital_status(state){
    return state.marital_status
}

export function reward_categories(state){
    return state.reward_categories
}

export function reward_departments(state){
    return state.reward_departments
}

export function reward_levels(state){
    return state.reward_levels
}

export function tags(state){
    return state.tags
}

export function countries(state){
    return state.countries.map(e => { return {...e, label: e.name, code: e.label} })
}

export function wildcard_pages(state){
    return state.wildcard_pages
}
export function trail_complete_categories(state){
    return state.trail_complete_categories
}

export function has_trailcomplete_null_category(state){
    return state.has_trailcomplete_null_category
}